import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Track } from '@app/core/models/Track';
import { TrackApiModel } from '@app/library/services/track.service';
import {
  TrackCoverMultipleSetFailure,
  TrackCoverMultipleSetRequest,
  TrackCoverMultipleSetSuccess,
  TrackEditFailure,
  TrackEditRequest,
  TrackEditSuccess,
} from '@app/library/states/tracks.actions';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { UiStoreHelperService } from '@radioking/shared/common-services';
import { Observable, Subscription } from 'rxjs';

interface DataInput {
  trackIdList: number[];
  track: Partial<TrackApiModel>;
  tracks: Track[];
  file?: File;
}

@Component({
  selector: 'rk-edit-multiple-track-modal',
  templateUrl: './edit-multiple-track-modal.component.html',
  styleUrls: ['./edit-multiple-track-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditMultipleTrackModalComponent implements OnInit, OnDestroy {
  isLoading$: Observable<boolean>;
  subscription = new Subscription();

  constructor(
    public readonly dialogRef: MatDialogRef<EditMultipleTrackModalComponent>,
    private readonly actions$: Actions,
    @Inject(MAT_DIALOG_DATA) public dataIn: DataInput,
    private readonly uiStore: UiStoreHelperService,
  ) {}

  ngOnInit(): void {
    this.isLoading$ = this.uiStore.getLoadingState(
      [TrackCoverMultipleSetRequest, TrackEditRequest],
      [
        TrackCoverMultipleSetSuccess,
        TrackCoverMultipleSetFailure,
        TrackEditSuccess,
        TrackEditFailure,
      ],
    );
    this.subscription.add(
      this.actions$
        .pipe(ofActionDispatched(TrackEditSuccess, TrackCoverMultipleSetSuccess))
        .subscribe(() => this.dialogRef.close()),
    );

    this.subscription.add(
      this.actions$
        .pipe(ofActionDispatched(TrackEditFailure))
        .subscribe(({ error }: TrackEditFailure) => {
          // OK anyway because its just a "Not modified"
          if (error.status === 304) {
            this.dialogRef.close();
          }
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  trackLength(): number {
    return this.dataIn.file ? this.dataIn.tracks.length : this.dataIn.trackIdList.length;
  }

  onSubmit() {
    if (this.dataIn.file) {
      this.editCover();
    } else {
      this.editTracks();
    }
  }

  @Dispatch()
  editCover() {
    return new TrackCoverMultipleSetRequest(this.dataIn.tracks, this.dataIn.file);
  }

  @Dispatch()
  editTracks() {
    return new TrackEditRequest(this.dataIn.trackIdList, this.dataIn.track);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
